import "./forgetpassword.css";
import {
  React,
  Button,
  DigitalSignage,
  useState,
  toast,
  useForgetpasswordMutation,
  useNavigate,
} from "../../../Libraries/Authentication/ForgetPassword/index";
import { InputText } from "primereact/inputtext";
import { Link, LoadingSpinner } from "../../../Libraries/Authentication/Login";
import { captureeventbaseanalytics } from "../../../Analytics/Google/AllAnalytics/Capturing";
import BoostBoardLogo from '../../../Assets/svgs/boostboard_logo.svg';
const ForgetPassword = () => {

  const [forgetpassword, { isloading }] = useForgetpasswordMutation();
  const navigate = useNavigate(null);
  const [data, setdata] = useState({
    username: "",
  });
  const handleForgetPwd = async (e) => {
  e.preventDefault();

    try {
      if (
        data.username.length > 0 &&
        data.username !== "" &&
        data.username !== null &&
        data.username !== undefined &&
        data.username !== "null" &&
        data.username !== "undefined"
      ) {
        const payload = new FormData();
        payload.append("txt_customer_id", data.username);
        const res = await forgetpassword(payload).unwrap();
        if (
          res.status === "true" &&
          res.connection === "true" 
          // res.message === "Email Sent" //removed in API-Shifting
        ) {
          toast.success(res.message);
          captureeventbaseanalytics(
            "Authentication",
            "BoostBoard_ForgetPassword",
            data.message
          );
          setTimeout(() => {
            navigate("/login");
          }, [1000]);
        } else {
          toast.error(res.message);
        }
      } else {
        toast.error("Username is empty");
      }
    } catch (error) {
      console.log(error);
      toast.error(error.error);
    }
  };

  return (
    <>
      {isloading ? <LoadingSpinner /> : null}
      <div
        className="bg_fp"
        style={{
          backgroundImage: `url(${"https://bbapi.nayatel.com/api/api/web/AuthBackgroundImage/authbg.png"}), url(${require("../../../Assets/Images/authbg.png")})`,
        }}
      >
        <div className="card_wrapper_fp">
          <div className="shadow rowdesign_fp">
            <div className="card_centered">
              <div className="auth_logo_fp">
                <img src={BoostBoardLogo} alt="logo" width="170px" />
              </div>
              <form className="forgetpassword" onSubmit={handleForgetPwd}>
                <div className="row inputfields">
                  <div className="col-md-12 col-lg-12 col-sm-12 label_login">
                    <label className="label_login">Username</label>
                    <InputText
                      autoComplete="off"
                      placeholder="Username"
                      className="p-inputtext-sm block mb-1 w-100"
                      onChange={(e) =>
                        setdata({ ...data, username: e.target.value })
                      }
                    />
                  </div>
                </div>

                <Button
                  sx={{
                    width: "100%",
                    borderRadius: "8px",
                    mt: "40px",
                  }}
                  variant="contained"
                  type="submit"
                  className="capitalized fs-14 fw-bold"
                >
                  Submit
                </Button>
              </form>

              <div className="forgettologin">
                <span className="backtologin">Back to login? &nbsp;</span>
                <Link
                  to="/login"
                  style={{ fontWeight: "bold", color: "#1A75E8" }}
                >
                  Login
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
